import { useState } from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/feature/Seo";
import { faqList } from "@/mocks/articles";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <>
      <Seo
        title="常见问题 FAQ - 樱花漫画"
        description="樱花漫画常见问题解答：网站定位、如何找漫画、内容原则、订阅与投稿等相关疑问，这里都有答案。"
        canonical="https://comicflower.github.io/faq"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: faqList.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        }}
      />
      <div className="mx-auto max-w-3xl px-4 pt-24 md:px-6 md:pt-28">
        <nav className="flex flex-wrap items-center gap-1 text-xs text-foreground-500" aria-label="面包屑">
          <Link to="/" className="hover:text-primary-700">首页</Link>
          <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
          <span className="text-foreground-800">常见问题</span>
        </nav>
        <div className="mt-4">
          <span className="inline-flex items-center gap-2 whitespace-nowrap text-xs font-medium uppercase tracking-widest text-primary-600">
            <span className="h-px w-6 bg-accent-500" aria-hidden="true"></span>
            FAQ
          </span>
          <h1 className="mt-3 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
            常见问题解答
          </h1>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            关于樱花漫画的常见疑问，这里都有答案。如果还有不清楚的地方，欢迎通过联系我们页面咨询。
          </p>
        </div>

        <div className="mt-8 space-y-3">
          {faqList.map((item, i) => {
            const open = openIdx === i;
            return (
              <div
                key={item.q}
                className={`overflow-hidden rounded-xl border transition-colors ${
                  open ? "border-primary-200 bg-background-50" : "border-background-200 bg-background-100"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? null : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={open}
                >
                  <span className="font-heading text-base font-bold text-foreground-950">
                    {item.q}
                  </span>
                  <i
                    className={`shrink-0 text-lg text-primary-600 transition-transform ${
                      open ? "ri-subtract-fill" : "ri-add-fill"
                    }`}
                    aria-hidden="true"
                  ></i>
                </button>
                {open && (
                  <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{item.a}</p>
                )}
              </div>
            );
          })}
        </div>

        <div className="mt-10 rounded-2xl border border-background-200 bg-background-100 p-6 text-center">
          <p className="text-sm text-foreground-600">没找到你想要的答案？</p>
          <Link
            to="/contact"
            className="mt-4 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-600"
          >
            联系我们
            <i className="ri-arrow-right-line text-sm" aria-hidden="true"></i>
          </Link>
        </div>
      </div>
    </>
  );
}